export default __webpack_public_path__ + "static/chocpops-health-2-desktop-8c06402ca025938e2a36bac17019146c.png";